import React, { createContext, useContext, useState } from 'react';
import { adminTranslations } from '../locales/adminTranslations';

const AdminLangContext = createContext();

export const AdminLangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('admin_lang') || 'en');

  const changeLang = (newLang) => {
    setLang(newLang);
    localStorage.setItem('admin_lang', newLang);
  };

  const t = (key) => adminTranslations[lang]?.[key] || adminTranslations.en?.[key] || key;

  return (
    <AdminLangContext.Provider value={{ lang, setLang: changeLang, t }}>
      {children}
    </AdminLangContext.Provider>
  );
};

export const useAdminLang = () => {
  const ctx = useContext(AdminLangContext);
  if (!ctx) throw new Error('useAdminLang must be used within AdminLangProvider');
  return ctx;
};
